var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Children, cloneElement, forwardRef, isValidElement, } from 'react';
import { BusStopItem } from './components/item/BusStopItem';
import { StyledBusStop, StyledBusStopList } from './styles/bus-stop.styled';
/**
 * The a11y considerations for this component are based on:
 * https://www.w3.org/WAI/tutorials/forms/multi-page/#using-step-by-step-indicator
 */
const BusStop = forwardRef(function BusStopWithRef(_a, ref) {
    var { children } = _a, props = __rest(_a, ["children"]);
    const total = Children.count(children);
    const mappedItems = Children.map(children, (child, index) => {
        if (isValidElement(child)) {
            return cloneElement(child, Object.assign({ step: index + 1, total }, child.props));
        }
        return child;
    });
    return (_jsx(StyledBusStop, Object.assign({}, props, { ref: ref, children: _jsx(StyledBusStopList, { children: mappedItems }) })));
});
BusStop.Item = BusStopItem;
export { BusStop };
